import { render, staticRenderFns } from "./waiver-zero-app.vue?vue&type=template&id=acefe916&scoped=true"
import script from "./waiver-zero-app.vue?vue&type=script&lang=ts"
export * from "./waiver-zero-app.vue?vue&type=script&lang=ts"
import style0 from "./waiver-zero-app.vue?vue&type=style&index=0&id=acefe916&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acefe916",
  null
  
)

export default component.exports